import React from 'react';
import moment from 'moment';
import { uuid } from 'uuidv4';
import { IconUpdate } from "../../components/IconUpdate";
import { IconBin } from "../../components/IconBin";
import { format } from 'date-fns';
// Global States for faster scheduling
import { useStore } from "../../contexts/store";

const RenderSlice = (onDeleteTimeslot, connectedExperts, growlStore) => {
  const {
    state,
    dispatch
  } = useStore();
  ;
  const {
    schedule,
    availabilityStore_imp
  } = state;
  const {
    timeslots
  } = { ...schedule
  };
  const renderSlots = Array.from(timeslots).map(ts => {
    const startTime = ts.time.start;
    const endTime = ts.time.end;
    let day = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 19,
        color: '#fff',
        fontWeight: '400'
      }
    }, moment(startTime).format('ddd').toUpperCase(), ","), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 19,
        lineHeight: '25px',
        fontWeight: '400'
      }
    }, moment(startTime).format('Do')), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 17
      }
    }, format(startTime, 'MMMM yyyy')));
    return /*#__PURE__*/React.createElement("div", {
      key: uuid(),
      id: "rmTs",
      className: "slideIn",
      style: {
        width: window && window.outerWidth < 768 ? '100%' : 'auto',
        display: 'flex',
        margin: '4px',
        zIndex: 1
      }
    }, /*#__PURE__*/React.createElement("div", {
      title: "Edit Timeslot",
      className: "slice-wrapper",
      onClick: () => {
        let dayToRender = moment(schedule.timeslots[0].time.start);

        if (moment(schedule.timeslots[0].time.start).toDate().getTime() <= Number(moment().format('x'))) {
          dayToRender = moment();
        }

        dispatch({
          type: 'UPDATE',
          payload: {
            dayToRender,
            readOnly: true,
            currentPath: 'calendarview'
          }
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        position: 'absolute',
        left: '9px',
        top: '9px'
      }
    }, /*#__PURE__*/React.createElement(IconUpdate, null)), /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'column',
        width: '150px'
      }
    }, day), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 19,
        fontWeight: '400',
        marginLeft: 8,
        paddingLeft: 8,
        alignItems: 'center',
        display: 'flex',
        borderLeft: window && window.outerWidth < 768 ? '0' : '2px solid rgba(255,255,255,.8)',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '150px'
      }
    }, /*#__PURE__*/React.createElement("div", null, format(startTime, 'HH:mm')), /*#__PURE__*/React.createElement("div", null, format(endTime, 'HH:mm')), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 16,
        color: 'rgba(255,255,255,0.9)'
      }
    }, "(", format(startTime, 'zzzz'), ")"))), /*#__PURE__*/React.createElement("div", {
      title: "Cancel Timeslot",
      className: "close-wrapper",
      onClick: async () => {
        await onDeleteTimeslot();
        availabilityStore_imp.init();
      }
    }, /*#__PURE__*/React.createElement(IconBin, null)));
  });
  return renderSlots;
};

export default RenderSlice;